const RED_BULL_REGEX = /Red Bull|RED BULL/g;

export function replaceRedBullWhitespaces(input: string) {
  return input
    .replace(RED_BULL_REGEX, "Red\xA0Bull")
    .replace(/\\r/g, "\r")
    .replace(/\\n/g, "\n");
}
